<template>
  <span v-if="valueType == 'TagSerializer'" class="label label-info">
    {{ value.name }}
  </span>
  <span v-else>{{value}}</span>
</template>
<script>
  export default {
    name: 'table-cell-inner',
    props: {
      value: {
        required: false
      },
      valueType: String
    }
  }
</script>



// WEBPACK FOOTER //
// TableCellInner.vue?0d9597e8